export const getTenantId = () => {
  const path = window.location.pathname
  const match = path.match(/^\/([^/]+)/)
  return match ? `${match[1]}` : ''
}
export const tenantId = getTenantId()